export enum Genders {
  Male = 1,
  Female = 2,
  Other = 3,
}
